import { Injectable } from '@angular/core';
import { BranchFunctionGroup } from 'src/app/_model/branch-function-group';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class BranchFunctionGroupsDaoService implements Resetable {
  public abstract saveBranchFunctionGroups(entries: BranchFunctionGroup[]): Promise<void>;
  public abstract createBranchFunctionGroup(entry: BranchFunctionGroup): Promise<BranchFunctionGroup>;
  public abstract getBranchFunctionGroups(): Promise<BranchFunctionGroup[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
